import { StyleSheet } from 'react-native';

import { colors, fonts, fontSizes, spacing } from '@/constants/theme';

export const styles = StyleSheet.create({
  centered: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: spacing.base,
    paddingHorizontal: spacing.lg,
  },
  caption: {
    fontFamily: fonts.body,
    fontSize: fontSizes.sm,
    color: colors.textMuted,
    textAlign: 'center',
  },
  checkCircle: {
    width: 96,
    height: 96,
    borderRadius: 9999,
    backgroundColor: colors.electricGreen,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: spacing.sm,
    shadowColor: colors.electricGreen,
    shadowOffset: { width: 0, height: 16 },
    shadowOpacity: 0.4,
    shadowRadius: 40,
    elevation: 8,
  },
  readyBody: {
    fontFamily: fonts.body,
    fontSize: fontSizes.base,
    color: colors.textMuted,
    textAlign: 'center',
    maxWidth: 280,
    lineHeight: 24,
  },
  failedReason: {
    fontFamily: fonts.body,
    fontSize: fontSizes.sm,
    color: colors.text,
    textAlign: 'center',
    maxWidth: 280,
  },
  errorText: {
    fontFamily: fonts.body,
    fontSize: fontSizes.xs,
    color: colors.danger,
    textAlign: 'center',
  },
  ctaStack: {
    width: '100%',
    marginTop: spacing.md,
  },
});
